module.exports = __webpack_public_path__ + "static/media/README.72a23fd8.md";